<div class="outside-box">
  @if(!production) {
  <div class="dev-banner">
    <p><strong>Development Mode</strong></p>
  </div>
  }
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>Reset Password</mat-card-title>
        <mat-card-subtitle>
          Please enter your new password below.
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Password</mat-label>
            <input matInput type="password" formControlName="newPassword" required autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Confirm New Password</mat-label>
            <input matInput type="password" formControlName="newPasswordConfirm" required autocomplete="off">

          </mat-form-field>

          <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button"
              [disabled]="loginForm.invalid || accountService.isLoading">
              Reset Password
            </button>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="additional-actions">
        <a routerLink="/login" class="action-link">Go to Log in</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>